import React from "react";

/**
 * Step Card Component for Documentation Steps
 */
const StepCard = ({ number, title, children, darkMode = false }) => {
  const theme = darkMode
    ? {
        cardBg: "#0f172a",
        border: "#334155",
        numberBg: "#3b82f6",
        text: "#e2e8f0",
        textSecondary: "#94a3b8",
      }
    : {
        cardBg: "#f8fafc",
        border: "#e2e8f0",
        numberBg: "#667eea",
        text: "#1e293b",
        textSecondary: "#64748b",
      };

  return (
    <div
      className="step-card"
      style={{
        display: "flex",
        gap: "20px",
        marginBottom: "24px",
        padding: "24px",
        backgroundColor: theme.cardBg,
        borderRadius: "12px",
        border: `1px solid ${theme.border}`,
        minWidth: 0,
        width: "100%",
      }}
    >
      <style>
        {`
          @media (max-width: 768px) {
            .step-card {
              flex-direction: column !important;
              gap: 12px !important;
            }
            .step-card > div:first-child {
              margin-bottom: 4px;
            }
          }
        `}
      </style>
      {/* Step Number */}
      <div
        style={{
          minWidth: "48px",
          height: "48px",
          borderRadius: "50%",
          backgroundColor: theme.numberBg,
          color: "white",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: "1.4rem",
          fontWeight: "700",
          flexShrink: 0,
        }}
      >
        {number}
      </div>

      {/* Step Content */}
      <div style={{ flex: 1, minWidth: 0, wordWrap: "break-word", overflowWrap: "break-word" }}>
        {title && (
          <h4
            style={{
              fontSize: "1.2rem",
              fontWeight: "600",
              marginBottom: "12px",
              color: theme.text,
              wordWrap: "break-word",
              overflowWrap: "break-word",
            }}
          >
            {title}
          </h4>
        )}
        <div style={{ color: theme.textSecondary, lineHeight: "1.6", wordWrap: "break-word", overflowWrap: "break-word" }}>
          {children}
        </div>
      </div>
    </div>
  );
};

export default StepCard;
